import React from 'react';
import Colors from "../../../../constants/Colorsv2";
import { Text, TouchableOpacity } from "../../../../globalComponents/NativeOverrides";
import { navigate } from '../../../../navigation/RootNavigation';

export const rti_playerEntity = (props:any) => {
    const entity = props.contentState.getEntity(props.entityKey).getData();
    return (
        <TouchableOpacity style={{display:'inline-block'}} onPress={() => navigate('SocialProfile', { player_id:entity.player_id })}>
            <Text size={14} color={Colors.brand.electric} weight='semibold'>{props.children}</Text>
        </TouchableOpacity>
    )
}


export const rti_tagEntity = (props:any) => {
    const entity = props.contentState.getEntity(props.entityKey).getData();
    return (
        <TouchableOpacity style={{display:'inline-block'}} onPress={() => navigate('SocialProfile', { player_id:entity.player_id })}>
            <Text size={14} color={Colors.brand.electric} weight='semibold'>{props.children}</Text>
        </TouchableOpacity>
    )
}